export default __webpack_public_path__ + "static/media/scientist.c6c7ca88.jpg";